import React from "react";
import './footer.css';
import logo from '../assets/logo_text.png'
import androidLogo from '../assets/img/icon/playStore.png'; // Replace with your Android logo path
import iosLogo from '../assets/img/icon/appleStore.png'; // Replace with your iOS logo path
import facebookLogo from '../assets/logo.png'; // Replace with your Facebook logo path
import twitterLogo from '../assets/logo.png'; // Replace with your Twitter logo path
import instagramLogo from '../assets/logo.png'; // Replace with your Instagram logo path

function Footer() {
    return (
        <div className="footer">
                
                <div className="logo-container">
                <img src={logo} alt="Company Logo" className="footer-logo" />
               
                </div>

                <div className="app-download-section">
             
          
                <p>Download the app</p>
                <a
                href='https://apps.apple.com/ch/app/food-allergy-card/id6448350429' target="_blank" rel="noopener noreferrer">
                        <img  className="store-logo"  src={androidLogo} alt="Download on Android" />
                    </a>
                    <a 
                    
                    href="https://apps.apple.com/us/app/food-allergy-card/id6448350429" target="_blank" rel="noopener noreferrer">
                        <img  className="store-logo"  src={iosLogo} alt="Download on iOS" />
                    </a>

                </div>

            <div className="first-componenet-content">

             

        

          
            </div>


                <div className="copyright">
                    &copy; {new Date().getFullYear()} Food Allergy Card. All rights reserved.
                </div>
            </div>

    );
}

export default Footer;
